const eceData1 = [
  {
    id: 1,
    category: "ECE",
    level: "hard",
    question:
      "Which effect limits the scaling of MOSFET threshold voltage in deep submicron technology?",
    options: [
      "Short-channel effects",
      "High gate resistance",
      "Avalanche breakdown",
      "Hot electron effect",
    ],
    answer: "Short-channel effects",
  },
  {
    id: 2,
    category: "ECE",
    level: "hard",
    question: "In control systems, what does 'Phase Margin' indicate?",
    options: [
      "Additional phase before instability",
      "Time delay in response",
      "Bandwidth of the system",
      "Gain at resonance",
    ],
    answer: "Additional phase before instability",
  },
  {
    id: 3,
    category: "ECE",
    level: "hard",
    question: "Why is a Hamming window used in FIR filter design?",
    options: [
      "To reduce spectral leakage",
      "To increase passband gain",
      "To achieve linear phase",
      "To increase stopband attenuation",
    ],
    answer: "To reduce spectral leakage",
  },
  {
    id: 4,
    category: "ECE",
    level: "hard",
    question: "A hold-time violation occurs when:",
    options: [
      "Data changes too soon after clock edge",
      "Setup time is too long",
      "Clock is skewed",
      "Flip-flop is disabled",
    ],
    answer: "Data changes too soon after clock edge",
  },
  {
    id: 5,
    category: "ECE",
    level: "hard",
    question: "Main advantage of OFDM is:",
    options: [
      "Mitigates frequency-selective fading",
      "Reduces PAPR",
      "Single-carrier simplicity",
      "Doppler immunity",
    ],
    answer: "Mitigates frequency-selective fading",
  },
  {
    id: 6,
    category: "ECE",
    level: "hard",
    question: "ENOB of an ADC represents:",
    options: [
      "Effective resolution considering noise and distortion",
      "Physical bit count",
      "Maximum sampling rate",
      "Number of comparators",
    ],
    answer: "Effective resolution considering noise and distortion",
  },
  {
    id: 7,
    category: "ECE",
    level: "hard",
    question: "Hot Carrier Injection in CMOS transistors is caused by:",
    options: [
      "High-energy carriers damaging gate oxide",
      "Excessive power consumption",
      "Source-drain tunneling",
      "Electromigration",
    ],
    answer: "High-energy carriers damaging gate oxide",
  },
  {
    id: 8,
    category: "ECE",
    level: "hard",
    question: "PLL capture range is:",
    options: [
      "Frequencies PLL can acquire lock",
      "Frequencies PLL can maintain lock",
      "Loop filter bandwidth",
      "Max phase error",
    ],
    answer: "Frequencies PLL can acquire lock",
  },
  {
    id: 9,
    category: "ECE",
    level: "hard",
    question: "Skin depth in a conductor is:",
    options: [
      "Depth where E-field drops to 1/e",
      "Insulator thickness",
      "Wavelength in material",
      "Distance for 50% power drop",
    ],
    answer: "Depth where E-field drops to 1/e",
  },
  {
    id: 10,
    category: "ECE",
    level: "hard",
    question: "RISC architecture differs from CISC because:",
    options: [
      "Simpler instructions and more registers",
      "Variable-length instructions",
      "Cannot perform floating-point ops",
      "No pipelining",
    ],
    answer: "Simpler instructions and more registers",
  },
  {
    id: 11,
    category: "ECE",
    level: "hard",
    question: "MESI protocol is used for:",
    options: [
      "Cache coherence in multi-core processors",
      "ROM-only systems",
      "Single-core cache",
      "Deeply pipelined CPUs",
    ],
    answer: "Cache coherence in multi-core processors",
  },
  {
    id: 12,
    category: "ECE",
    level: "hard",
    question: "Viterbi algorithm is used for:",
    options: [
      "Decoding most likely state sequence in HMM",
      "FFT computation",
      "IIR filter design",
      "Signal compression",
    ],
    answer: "Decoding most likely state sequence in HMM",
  },
  {
    id: 13,
    category: "ECE",
    level: "hard",
    question: "ROC for a non-causal stable LTI system is:",
    options: [
      "Annulus in z-plane",
      "Disk from origin",
      "Entire z-plane",
      "Disk from infinity",
    ],
    answer: "Annulus in z-plane",
  },
  {
    id: 14,
    category: "ECE",
    level: "hard",
    question: "Barkhausen criterion for oscillation:",
    options: [
      "Loop gain = 1, phase shift 0°/360°",
      "Loop gain < 1, phase shift 180°",
      "Loop gain > 1, phase shift 90°",
      "Input = output impedance",
    ],
    answer: "Loop gain = 1, phase shift 0°/360°",
  },
  {
    id: 15,
    category: "ECE",
    level: "hard",
    question: "Antenna beamwidth is inversely proportional to:",
    options: [
      "Antenna physical size",
      "Operating frequency",
      "Input power",
      "Free-space impedance",
    ],
    answer: "Antenna physical size",
  },
  {
    id: 16,
    category: "ECE",
    level: "hard",
    question: "Power-Delay Product measures:",
    options: [
      "Energy per switching event",
      "Max frequency",
      "Total power",
      "Propagation delay",
    ],
    answer: "Energy per switching event",
  },
  {
    id: 17,
    category: "ECE",
    level: "hard",
    question: "E-k diagram shows:",
    options: [
      "Electron energy vs momentum",
      "I-V characteristic",
      "Doping profile",
      "Transistor layout",
    ],
    answer: "Electron energy vs momentum",
  },
  {
    id: 18,
    category: "ECE",
    level: "hard",
    question: "Gilbert Cell is used as:",
    options: [
      "Frequency mixer/analog multiplier",
      "High-gain amplifier",
      "Precision rectifier",
      "VCO",
    ],
    answer: "Frequency mixer/analog multiplier",
  },
  {
    id: 19,
    category: "ECE",
    level: "hard",
    question: "Aliasing occurs due to:",
    options: [
      "High frequencies appearing as low",
      "Quantization error",
      "ADC noise",
      "Non-linear phase",
    ],
    answer: "High frequencies appearing as low",
  },
  {
    id: 20,
    category: "ECE",
    level: "hard",
    question: "Displacement current is used in which Maxwell equation?",
    options: [
      "Ampère's Law",
      "Faraday's Law",
      "Gauss's Law",
      "Gauss for Magnetism",
    ],
    answer: "Ampère's Law",
  },
  {
    id: 21,
    category: "ECE",
    level: "hard",
    question: "In VLSI testing, a scan chain improves:",
    options: [
      "Controllability and observability of flip-flops",
      "Power efficiency",
      "Speed of execution",
      "Physical defect detection",
    ],
    answer: "Controllability and observability of flip-flops",
  },
  {
    id: 22,
    category: "ECE",
    level: "hard",
    question: "Shannon-Hartley theorem relates channel capacity to:",
    options: [
      "Bandwidth and SNR",
      "Data rate and packet size",
      "Modulation type and symbol rate",
      "Antenna gain and power",
    ],
    answer: "Bandwidth and SNR",
  },
  {
    id: 23,
    category: "ECE",
    level: "hard",
    question: "FinFET advantage over planar MOSFET is:",
    options: [
      "Better electrostatic channel control",
      "Cheaper fabrication",
      "High-voltage only",
      "Lower on-resistance but high leakage",
    ],
    answer: "Better electrostatic channel control",
  },
  {
    id: 24,
    category: "ECE",
    level: "hard",
    question: "Channel equalization compensates for:",
    options: [
      "Inter-symbol interference",
      "Transmission power",
      "Frequency band selection",
      "Data encryption",
    ],
    answer: "Inter-symbol interference",
  },
  {
    id: 25,
    category: "ECE",
    level: "hard",
    question: "Sallen-Key topology is used to design:",
    options: ["Active filter", "Digital logic", "Power amplifier", "PLL"],
    answer: "Active filter",
  },
  {
    id: 26,
    category: "ECE",
    level: "hard",
    question: "Moving clockwise on Smith chart corresponds to:",
    options: [
      "Towards generator along transmission line",
      "Towards load",
      "Series capacitor addition",
      "Series inductor addition",
    ],
    answer: "Towards generator along transmission line",
  },
  {
    id: 27,
    category: "ECE",
    level: "hard",
    question: "Early effect in BJT is:",
    options: [
      "Reduction in base width with Vcb",
      "Collector current change due to Vbe",
      "Avalanche breakdown",
      "Emitter efficiency rise with temperature",
    ],
    answer: "Reduction in base width with Vcb",
  },
  {
    id: 28,
    category: "ECE",
    level: "hard",
    question: "Key difference: Mealy vs Moore FSM is:",
    options: [
      "Moore output depends only on state",
      "Mealy has fewer states",
      "Mealy output depends only on state",
      "Moore asynchronous",
    ],
    answer: "Moore output depends only on state",
  },
  {
    id: 29,
    category: "ECE",
    level: "hard",
    question: "Differential Non-Linearity in DAC/ADC refers to:",
    options: [
      "Max deviation of 1 LSB from ideal step",
      "Overall curvature",
      "Total unadjusted error",
      "Noise performance",
    ],
    answer: "Max deviation of 1 LSB from ideal step",
  },
  {
    id: 30,
    category: "ECE",
    level: "hard",
    question: "Data hazard in pipelines occurs when:",
    options: [
      "Instruction depends on previous incomplete instruction",
      "Branch unresolved",
      "Hardware resource conflict",
      "Cache miss",
    ],
    answer: "Instruction depends on previous incomplete instruction",
  },
  {
    id: 31,
    category: "ECE",
    level: "hard",
    question: "Fermi-Dirac distribution describes:",
    options: [
      "Probability of electron occupation at a temperature",
      "Electron energy vs momentum",
      "Density of states",
      "I-V of pn junction",
    ],
    answer: "Probability of electron occupation at a temperature",
  },
  {
    id: 32,
    category: "ECE",
    level: "hard",
    question: "Chebyshev filter differs from Butterworth by:",
    options: [
      "Sharper transition with passband ripple",
      "Maximally flat passband",
      "Linear phase",
      "No stopband sidelobes",
    ],
    answer: "Sharper transition with passband ripple",
  },
  {
    id: 33,
    category: "ECE",
    level: "hard",
    question: "Static Timing Analysis (STA) is used to:",
    options: [
      "Check setup/hold without full simulation",
      "Verify functional logic",
      "Analyze idle power",
      "Detect physical defects",
    ],
    answer: "Check setup/hold without full simulation",
  },
  {
    id: 34,
    category: "ECE",
    level: "hard",
    question: "Direct-Sequence Spread Spectrum is mainly used to:",
    options: [
      "Resist narrowband interference",
      "Increase data rate",
      "Simplify RF front-end",
      "Reduce transmission power",
    ],
    answer: "Resist narrowband interference",
  },
  {
    id: 35,
    category: "ECE",
    level: "hard",
    question: "Waveguide allows propagation of:",
    options: [
      "Frequencies above cutoff",
      "All frequencies",
      "Only TEM waves",
      "Zero-loss signals",
    ],
    answer: "Frequencies above cutoff",
  },
  {
    id: 36,
    category: "ECE",
    level: "hard",
    question: "Miller Effect is:",
    options: [
      "Apparent input capacitance increase due to inverting gain",
      "Gain reduction at high frequency",
      "Harmonics generation",
      "Bias shift with temperature",
    ],
    answer: "Apparent input capacitance increase due to inverting gain",
  },
  {
    id: 37,
    category: "ECE",
    level: "hard",
    question: "Power Spectral Density describes:",
    options: [
      "Distribution of signal power over frequency",
      "Signal amplitude over time",
      "Total signal power",
      "Phase components",
    ],
    answer: "Distribution of signal power over frequency",
  },
  {
    id: 38,
    category: "ECE",
    level: "hard",
    question: "Clock Skew refers to:",
    options: [
      "Difference in arrival time of clock at different circuit points",
      "Clock jitter",
      "Duty cycle deviation",
      "Single flip-flop delay",
    ],
    answer: "Difference in arrival time of clock at different circuit points",
  },
  {
    id: 39,
    category: "ECE",
    level: "hard",
    question: "Gunn Effect exhibits:",
    options: [
      "Negative differential resistance in some semiconductors",
      "Forward-biased light emission",
      "Hall voltage generation",
      "Avalanche breakdown",
    ],
    answer: "Negative differential resistance in some semiconductors",
  },
  {
    id: 40,
    category: "ECE",
    level: "hard",
    question: "Cascode amplifier has a common-emitter stage followed by:",
    options: [
      "Common-base stage",
      "Common-collector stage",
      "Common-emitter stage",
      "Common-drain stage",
    ],
    answer: "Common-base stage",
  },
  {
    id: 41,
    category: "ECE",
    level: "hard",
    question: "LMS algorithm in adaptive filters is used to:",
    options: [
      "Iteratively minimize mean square error",
      "Set cutoff frequency",
      "Perform Fourier transform",
      "Convert analog filter to digital",
    ],
    answer: "Iteratively minimize mean square error",
  },
  {
    id: 42,
    category: "ECE",
    level: "hard",
    question: "Mutual Information I(X;Y) measures:",
    options: [
      "Information Y provides about X",
      "Total uncertainty of X",
      "Channel capacity",
      "Error probability",
    ],
    answer: "Information Y provides about X",
  },
  {
    id: 43,
    category: "ECE",
    level: "hard",
    question: "Flicker Noise (1/f noise) is:",
    options: [
      "Noise inversely proportional to frequency",
      "White noise",
      "High-frequency noise",
      "Shot noise",
    ],
    answer: "Noise inversely proportional to frequency",
  },
  {
    id: 44,
    category: "ECE",
    level: "hard",
    question: "Radix-2 FFT algorithm:",
    options: [
      "Breaks DFT recursively into smaller DFTs",
      "Converts signal to base-2",
      "Improves frequency resolution",
      "Works only for prime-length signals",
    ],
    answer: "Breaks DFT recursively into smaller DFTs",
  },
  {
    id: 45,
    category: "ECE",
    level: "hard",
    question: "Electromigration in ICs is:",
    options: [
      "Metal atom displacement due to electron flow",
      "Electron movement in p-n junction",
      "Ion movement in battery",
      "Etching during fabrication",
    ],
    answer: "Metal atom displacement due to electron flow",
  },
  {
    id: 46,
    category: "ECE",
    level: "hard",
    question: "S-parameter S21 indicates:",
    options: [
      "Forward transmission from Port 1 to 2",
      "Input reflection at Port 1",
      "Output reflection at Port 2",
      "Reverse transmission from Port 2 to 1",
    ],
    answer: "Forward transmission from Port 1 to 2",
  },
  {
    id: 47,
    category: "ECE",
    level: "hard",
    question: "Switched-capacitor resistor is implemented using:",
    options: [
      "Capacitor, switches, and clock",
      "Inductor and clock",
      "Small resistor",
      "BJT in active region",
    ],
    answer: "Capacitor, switches, and clock",
  },
  {
    id: 48,
    category: "ECE",
    level: "hard",
    question: "Laplace transform of δ(t) is:",
    options: ["0", "1", "1/s", "s"],
    answer: "1",
  },
  {
    id: 49,
    category: "ECE",
    level: "hard",
    question: "Eb/N0 in satellite link represents:",
    options: [
      "Normalized SNR determining BER",
      "Link bandwidth",
      "Antenna size",
      "Transmitter power",
    ],
    answer: "Normalized SNR determining BER",
  },
  {
    id: 50,
    category: "ECE",
    level: "hard",
    question: "Quantum tunneling in MOSFETs refers to:",
    options: [
      "Leakage current through thin gate oxide",
      "Desired carrier flow",
      "Electron-hole generation due to light",
      "Atomic movement in silicon",
    ],
    answer: "Leakage current through thin gate oxide",
  },
];

export default eceData1;
